import "~/misc/common";
import { loader, p } from "~/misc/common";
import { Controller } from "@hotwired/stimulus";
import Cookies from 'js-cookie';
import moment from "moment";
import { Calendar, EventApi, EventDropArg, FormatterInput } from '@fullcalendar/core';
import interactionPlugin from '@fullcalendar/interaction';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import huLocale from '@fullcalendar/core/locales/hu';
import '~/styles/calendar.scss';
import { Popover } from "bootstrap";

import { initCalLessons } from "./lessons";
import { initCalGroups } from "./groups";
import { initCalSpecDays } from "./spec_days";
import { initCalMissions } from "./missions";
import { initCalTrainings } from "./trainings";

export interface CalendarOpts {
  user_id: number;
  selectable: boolean;
  calendar_min?: number;
  calendar_max?: number;
  spec_days: boolean;
  missions: boolean;
  trainings_create: boolean;
}

export default class extends Controller {
  connect() {
    console.log("initCalendar");
    const opts = $('#user').data('opts') as CalendarOpts;

    let popover: bootstrap.Popover | null;
    let calendarView: string = Cookies.get('calendarDefaultView') ?? 'timeGridWeek';
    if (!['dayGridMonth', 'timeGridWeek', 'timeGridDay'].includes(calendarView)) calendarView = 'timeGridWeek';
    const calendarDate = (!Cookies.get('calendarDefaultDate')) ? moment() : moment(Cookies.get('calendarDefaultDate'));
    const dayStartC = opts.calendar_min || 8;
    const dayEndC = opts.calendar_max || 22;
    let dayStart = dayStartC;
    let dayEnd = dayEndC;

    const calendar = new Calendar($('#calendar')[0], {
      plugins: [interactionPlugin, dayGridPlugin, timeGridPlugin],
      themeSystem: 'bootstrap5',
      headerToolbar: {
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,timeGridDay'
      },
      initialDate: calendarDate.toDate(),
      initialView: calendarView,
      selectable: opts.selectable,
      snapDuration: "00:05",
      selectMirror: true,
      editable: false,
      firstDay: 1,
      slotMinTime: `${dayStart.toString().padStart(2, "0")}:00:00`,
      slotMaxTime: `${dayEnd.toString().padStart(2, "0")}:00:00`,
      allDayText: '',
      height: "auto",
      eventTextColor: "black",
      eventDisplay: "block",
      locale: huLocale,
      slotLabelFormat: {
        hour: '2-digit',
        hour12: false
      },
      dayMaxEventRows: 4,
      //eventOrder: 'weight',
      nowIndicator: true,
      eventClick: function (info) {
        console.log(info);
        showPopover(info.el, info.event);
      },
      eventContent: function (arg) {
        const fmt: FormatterInput = {
          hour: "numeric",
          minute: "2-digit",
          hour12: false
        };
        const elTime = document.createElement('div');
        elTime.classList.add('fc-event-time');
        if (arg.event.start && !arg.event.allDay) {
          const span = document.createElement('span');
          span.classList.add('fc-event-time-start');
          span.textContent = calendar.formatDate(arg.event.start, fmt);
          elTime.appendChild(span);
        }
        if (arg.event.end && !arg.event.allDay) {
          const span = document.createElement('span');
          span.classList.add('fc-event-time-end');
          span.textContent = ' - ' + calendar.formatDate(arg.event.end, fmt);
          elTime.appendChild(span);
        }
        const elTitle = document.createElement('div');
        elTitle.classList.add('fc-event-title');
        elTitle.innerHTML = arg.event.title;
        if (arg.event.extendedProps.time_icon) {
          $(elTitle).prepend('<img src="' + arg.event.extendedProps.time_icon + '"/>');
        }
        return { domNodes: [elTime, elTitle] };
      },
      eventDrop: eventDrop,
      datesSet: function (arg) {
        console.log(arg);
        Cookies.set('calendarDefaultDate', arg.view.currentStart.toISOString(), {
          expires: 10,
          path: '/'
        });
        Cookies.set('calendarDefaultView', arg.view.type, {
          expires: 10,
          path: '/'
        });
        if (arg.view.type == 'dayGridMonth') {
          $('#wholeDay').hide();
        } else {
          $('#wholeDay').show();
        }
        const url = `/lesson_lockings/stats?date=${moment(arg.view.currentStart).format()}&user_id=${opts.user_id}`;
        $.get(url, function (data) {
          $('#stats').empty();
          $('#stats').html(data);
        });
      },
      select: function (info) {
        p(info);
        calendar.unselect();
        if ($("#btnNewContainer button:not([style*='display: none'])").length == 0) {
          return;
        }
        const start = info.start;
        const end = info.end;
        if (info.allDay) {
          start.setHours(8);
          end.setHours(end.getHours() - 6);
        }
        const newQuery = `started_at=${moment(start).format()}&finished_at=${moment(end).format()}&user_id=${opts.user_id}`;
        console.log(newQuery);
        $("#modalNewEntry").data("new-query", newQuery);
        $("#modalNewEntry").modal("show");
      }
    });
    calendar.render();

    calendar.addEventSource({ url: '/calendar/holidays.json' });
    initCalGroups(calendar, opts);
    initCalLessons(calendar, opts);
    initCalSpecDays(calendar, opts);
    initCalMissions(calendar, opts);
    initCalTrainings(calendar, opts);

    function eventDrop(arg: EventDropArg) {
      const event = arg.event;
      p(event);
      if (!event.start || !event.end || event.allDay) {
        arg.revert();
        return;
      }
      loader(true);
      $.ajax({
        url: `teaching_times/${event.extendedProps.tt_id}.json`,
        type: 'PUT',
        data: {
          teaching_time: {
            dow_id: (event.start.getDay() + 6) % 7,
            start_s: (event.start.getHours() * 60 + event.start.getMinutes()) * 60,
            end_s: (event.end.getHours() * 60 + event.end.getMinutes()) * 60
          }
        },
        success: function (result) {
          loader(false);
          console.log(result);
          if (result.success) {
            //location.reload();
          } else {
            alert(Object.values(result.error).flat().join("\n"));
            arg.revert();
            //location.reload();
          }
        }
      });
    }

    $('#wholeDay').on('click', function (e) {
      e.preventDefault();
      dayStart = (dayStart == dayStartC) ? 0 : dayStartC;
      dayEnd = (dayEnd == dayEndC) ? 24 : dayEndC;
      $(this).toggleClass('active');
      $(this).blur();
      calendar.setOption('slotMinTime', `${dayStart.toString().padStart(2, "0")}:00:00`);
      calendar.setOption('slotMaxTime', `${dayEnd.toString().padStart(2, "0")}:00:00`);
    });

    $(window).on('click', function () {
      hidePopover();
    });

    function hidePopover() {
      if (popover) { popover.dispose(); popover = null; }
    }

    function showPopover(element: Element, calEvent: EventApi) {
      hidePopover();
      var a_event = element;
      if (calEvent.extendedProps.details_url) {
        $.get(calEvent.extendedProps.details_url, function (d) {
          //console.log(d);
          popover = new Popover(a_event, {
            title: calEvent.title,
            trigger: 'manual',
            placement: 'auto',
            content: d,
            container: 'body',
            html: true
          });
          popover.show();
        });
      }
    }
  }
}
